<template>
	<v-dialog
		v-model="model"
		max-width="480"
	>
		<v-card>
			<v-card-title>
				<div class="text-truncate">
					Deseja Excluir "{{ nome }}"?
				</div>
			</v-card-title>
			<v-card-text>
				Essa ação é irreversível...
			</v-card-text>
			<v-card-actions>
				<v-btn
					text
					color="error"
					@click="handleExclusao"
					:loading="excluindo"
					:disabled="excluindo"
				> Sim </v-btn>
				<v-btn
					text
					color="grey"
					class="ml-auto"
					:disabled="excluindo"
					@click="() => model = false"
				> Não </v-btn>
			</v-card-actions>
		</v-card>

        <template
            v-for="(_, name) in $scopedSlots"
            #[name]="slotProps = {}"
        >
			<slot
				v-bind="slotProps"
				:name="name"
			/>
		</template>
	</v-dialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

const props = defineProps<{
  value: boolean,
  nome: string,
  onExcluir?: () => unknown | Promise<unknown>,
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
}>()

const model = computed<boolean>({
  get: () => props.value,
  set: (v) => emit('input', v),
})

const excluindo = ref(false)

async function handleExclusao() {
	excluindo.value = true

	try {
		if (props.onExcluir) {
			await props.onExcluir()
		}
		model.value = false
	} finally {
		excluindo.value = false
	}
}
</script>